import React, { useCallback, useEffect, useState } from "react";
import classes from "./OrderStatus.module.css";
import { useSelector } from "react-redux";
import { initialTableData } from "../lib/InitialOrderStatus";
import useLang from "../hooks/useLang";
import { useNavigate } from "react-router-dom";
import OrderStatusCard from "./OrderStatusCard";
import { orderStatusColor } from "../lib/orderStatusColors";
import { Modal } from "antd";
import { ReactComponent as Register } from "../assets/register-status.svg";

type OrderStatusProps = {
	orderData?: any[];
	descProp?: string;
	numberProp?: string;
};

const OrderStatus: React.FC<OrderStatusProps> = ({
	orderData,
	descProp,
	numberProp,
}) => {
	const reduxData = useSelector((state: any) => state?.order?.orderData);
	const [ordersCount, setOrdersCount] = useState<any[]>(initialTableData);
	const [showModal, setShowModal] = useState(false);

	const navigate = useNavigate();

	const { strings } = useLang("initialOrderStatus");

	const translateOrderDescriptions = (statusId: number) => {
		let translatedDescription = "";

		switch (statusId) {
			case 1:
				translatedDescription = strings?.registered;
				break;
			case 2:
				translatedDescription = strings?.waitingPickup;
				break;
			case 3:
				translatedDescription = strings?.pickedUp;
				break;
			case 4:
				translatedDescription = strings?.inStorage;
				break;
			case 5:
				translatedDescription = strings?.transport;
				break;
			case 6:
				translatedDescription = strings?.delivered;
				break;
			case 7:
				translatedDescription = strings?.rejected;
				break;
			case 8:
				translatedDescription = strings?.pending;
				break;
			case 9:
				translatedDescription = strings?.awaitingWithdrawal;
				break;
			case 10:
				translatedDescription = strings?.returned;
				break;
			case 11:
				translatedDescription = strings?.exchange;
				break;
			case 12:
				translatedDescription = strings?.redirected;
				break;
			case 13:
				translatedDescription = strings?.returnStorage;
				break;
			case 14:
				translatedDescription = strings?.internationalTransport;
				break;
			case 15:
				translatedDescription = strings?.exchangeReturn;
				break;
			case 16:
				translatedDescription = strings?.refunded;
				break;
			case 17:
				translatedDescription = strings?.cancelled;
				break;
			case 18:
				translatedDescription = strings?.returnSlip;
				break;
			case 1410:
				translatedDescription = strings?.returning;
				break;
			case 144:
				translatedDescription = strings?.internationalStorage;
				break;
			default:
				translatedDescription = "";
				break;
		}
		return translatedDescription;
	};

	const orderCountByStatus = (data: any) => {
		if (data) {
			const updatedData = initialTableData.map((item) => {
				const matchingItemFromAPI = data?.find(
					(apiItem: any) => apiItem.statusId === item.id
				);
				return matchingItemFromAPI
					? {
							...item,
							numberOfOrders:
								matchingItemFromAPI.numberOfOrders || 0,
					  }
					: item;
			});
			setOrdersCount(updatedData);
		}
	};

	useEffect(() => {
		if (reduxData) {
			orderCountByStatus(reduxData);
		}
	}, [reduxData]);

	const handleStatusClick = (statusId: any) => {
		navigate("/order", {
			state: { statusFilter: statusId ? [statusId] : null },
		});
	};
	const statusColors = [
		"#4F16C2",
		"#1E90FF",
		"#32CD32",
		"#EC132D",
		"#909090",
		"#C27316",
	];
	const renderStatusColor = orderStatusColor;

	const allowedIds = [1, 5, 6, 10, 8, 4];

	const firstTwoStatuses = [1, 5];

	const otherModalStatuses = [6, 2, 7, 11, 10, 8, 4, 144, 12, 1410, 3, 14];

	return (
		<>
			<div className={classes.statusContainer}>
				<div className={classes.firstStatus}>
					<div className={classes.topHeader}>
						<p className={classes.StatisticTitle}>
							Statistikat Gjenerale
						</p>
						<p
							className={classes.showAll}
							onClick={() => setShowModal(true)}
						>
							Shiko të gjitha
						</p>
					</div>
					<div className={classes.mainStatus}>
						{allowedIds.map((id, index) => {
							const data = ordersCount.find(
								(order) => order.id === id
							);
							return data ? (
								<OrderStatusCard
									onClick={() => handleStatusClick(data.id)}
									key={index}
									statusName={translateOrderDescriptions(
										data.id
									)}
									statusCount={data.numberOfOrders}
									statusColor={renderStatusColor(data.id)}
								/>
							) : null;
						})}
					</div>
				</div>
			</div>
			<Modal
				title="Statistikat Gjenerale"
				open={showModal}
				onCancel={() => setShowModal(false)}
				footer={null}
				className={classes.modal}
			>
				<div className={classes.firstRow}>
					{firstTwoStatuses.map((id, index) => {
						const data = ordersCount.find(
							(order) => order.id === id
						);
						return data ? (
							<OrderStatusCard
								onClick={() => handleStatusClick(data.id)}
								key={index}
								statusName={translateOrderDescriptions(data.id)}
								statusCount={
									data[numberProp || "numberOfOrders"]
								}
								statusColor={renderStatusColor(data.id)}
							/>
						) : null;
					})}
				</div>

				<div className={classes.remainingRows}>
					{otherModalStatuses.map((id, index) => {
						const data = ordersCount.find(
							(order) => order.id === id
						);
						return data ? (
							<OrderStatusCard
								onClick={() => handleStatusClick(data.id)}
								key={index}
								statusName={translateOrderDescriptions(data.id)}
								statusCount={
									data[numberProp || "numberOfOrders"]
								}
								statusColor={renderStatusColor(data.id)}
							/>
						) : null;
					})}
				</div>
			</Modal>
		</>
	);
};

export default OrderStatus;
